import { render } from "./ResultsPostGrad.vue?vue&type=template&id=1cab5dde"
import script from "./ResultsPostGrad.vue?vue&type=script&lang=js"
export * from "./ResultsPostGrad.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bdavies/Documents/git hub/undergraduate-degree-classification-calculator/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCircularProgress,QIcon});
